// extracted by mini-css-extract-plugin
export var layoutContainer = "_8e-0";
export var layoutContainerNoRounding = "_8e-6";
export var layoutContainerOpen = "_8e-5";
export var layoutContainerResizing = "_8e-1";
export var mainContent = "_8e-2";
export var resizeDivider = "_8e-3";
export var slidePanel = "_8e-4";